import React from "react";

import * as styles from "./styles.module.scss";

const Border = () => (
  <div className={styles.container}>
    <div className={styles.border} />
  </div>
);

export default Border;
